'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactHabitat = require('react-habitat');

var _reactHabitat2 = _interopRequireDefault(_reactHabitat);

var _reactHabitatRedux = require('react-habitat-redux');

var _iamOpenIdConnectImplicitFlow = require('iam-open-id-connect-implicit-flow');

var _configureStore = require('./store/configureStore');

var _configureStore2 = _interopRequireDefault(_configureStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HabitatLauncher = function (_ReactHabitat$Bootstr) {
  _inherits(HabitatLauncher, _ReactHabitat$Bootstr);

  function HabitatLauncher(stuff) {
    _classCallCheck(this, HabitatLauncher);

    var _this = _possibleConstructorReturn(this, (HabitatLauncher.__proto__ || Object.getPrototypeOf(HabitatLauncher)).call(this, stuff));

    _this.numberOfApps = 0;
    _this.appsTriggered = 0;
    return _this;
  }

  _createClass(HabitatLauncher, [{
    key: 'waitToSetContainer',
    value: function waitToSetContainer(containerBuilder) {
      var _this2 = this;

      var readyStateCheckInterval = setInterval(function () {
        if (_this2.numberOfApps !== 0 && _this2.numberOfApps === _this2.appsTriggered) {
          clearInterval(readyStateCheckInterval);
          _this2.setContainer(containerBuilder.build());
        }
      }, 10);
    }
  }, {
    key: 'startRoutes',
    value: function startRoutes(routes, containerBuilder) {
      var _this3 = this;

      this.numberOfApps = routes.length;
      routes.forEach(function (route) {
        route.load(containerBuilder, function () {
          _this3.appsTriggered++;
        });
      });

      this.waitToSetContainer(containerBuilder);
    }
  }, {
    key: 'startWithoutAem',
    value: function startWithoutAem(store, routes, containerBuilder, loginConfigs) {
      var _this4 = this;

      var requiredLoggedInClientIds = [];
      var unsubscribe = store.subscribe(function () {
        if (store.getState().auth && store.getState().auth.clients) {
          Object.keys(store.getState().auth.clients).forEach(function (clientKey) {
            var client = store.getState().auth.clients[clientKey];
            if (client && (client.isLoggedIn === true || client.loginProcessRunning === false)) {
              var index = requiredLoggedInClientIds.indexOf(clientKey);
              requiredLoggedInClientIds.splice(index, 1);
            }
          });
        }
        if (requiredLoggedInClientIds.length === 0) {
          _this4.startRoutes(routes, containerBuilder);
          unsubscribe();
        }
      });

      var currentLocation = window.location.href;

      // Already prepared for login library allowing more than one client id
      loginConfigs.forEach(function (config) {
        var clientId = config.iamConfig.client_id;
        if (requiredLoggedInClientIds.indexOf(clientId) === -1) {
          requiredLoggedInClientIds.push(clientId);

          // Set the current URI as redirect URI for login
          var iamConfigRedirectUrl = _extends({}, config.iamConfig, {
            loginParameter: _extends({}, config.iamConfig.loginParameter, {
              redirect_uri: currentLocation
            })
          });

          store.dispatch((0, _iamOpenIdConnectImplicitFlow.login)(iamConfigRedirectUrl, true));
        }
      });
    }
  }, {
    key: 'startRootApp',
    value: function startRootApp(routes, miniAppNames, axiosClients) {
      var store = (0, _configureStore2.default)({}, axiosClients);

      // Create a new container builder
      var containerBuilder = new _reactHabitat2.default.ContainerBuilder();

      // Set a new 'Redux' factory for the store
      containerBuilder.factory = new _reactHabitatRedux.ReduxDomFactory(store);

      var loginConfigs = routes.filter(function (route) {
        return !!miniAppNames.find(function (appName) {
          return appName === route.routeName;
        }).iamConfig;
      });

      if (loginConfigs !== null && loginConfigs.length > 0) {
        this.startWithoutAem(store, routes, containerBuilder, loginConfigs);
      } else {
        this.startRoutes(routes, containerBuilder);
      }
    }
  }]);

  return HabitatLauncher;
}(_reactHabitat2.default.Bootstrapper);

exports.default = HabitatLauncher;